<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Profile</div>
            <div class="subtitle-2">
              {{ this.title }}
            </div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel()">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <!-- {{ entityProfile }} -->
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">Google Maps Url</div>
              <v-text-field
                v-model="googleUrl"
                hide-details
                dense
                outlined
                placeholder="Google Maps URL"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Feature Image</div>

              <v-layout align-center>
                <v-flex>
                  <v-btn
                    color="primary"
                    class="text-none subtitle-2"
                    @click="openImageGallery"
                  >
                    <v-icon small class="mr-2">mdi-image-multiple</v-icon>
                    Image Gallery</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-layout v-if="imageUrl" class="mt-3">
                <v-flex xs4>
                  <v-card>
                    <v-img
                      gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                      aspect-ratio="1"
                      :lazy-src="imageUrl"
                      :src="imageUrl"
                    >
                      <v-layout>
                        <v-btn dark icon @click="galleryImageDeselect">
                          <v-icon> mdi-close </v-icon>
                        </v-btn>
                      </v-layout>
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">The Story</div>
              <v-textarea
                rows="3"
                v-model="about"
                hide-details
                dense
                outlined
                placeholder="Tell us about the place"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Gallery</div>
              <v-btn
                class="text-none subtitle-2"
                color="primary"
                @click="openImageGalleryMultipleSelect"
              >
                <v-icon small class="mr-2"> mdi-image-multiple </v-icon>
                Image Gallery
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout class="mt-2" wrap>
            <v-card
              class="mr-3 mb-3"
              v-for="(image, i) in galleryImages"
              :key="i"
              width="100"
            >
              <v-img :src="image.url" aspect-ratio="1">
                <v-btn
                  class="ma-1"
                  @click="removeGallerySelectedImage(i)"
                  fab
                  x-small
                >
                  <v-icon> mdi-close </v-icon>
                </v-btn>
              </v-img>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <image-gallery @selectImage="galleryImageSelect" ref="imageGalleryRef" />
    <image-gallery-multiple-select
      @save="updateSelectedImages"
      ref="imageGalleryMultipleSelectRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import firebase from "firebase";
import ImageGallery from "@/modules/Assets/components/ImageGallery";
import ImageGalleryMultipleSelect from "@/modules/Assets/components/ImageGalleryMultipleSelect";

export default {
  components: {
    ImageGallery,
    ImageGalleryMultipleSelect,
  },
  props: {
    entity: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      name: "",
      googleUrl: "",
      featureImage: "",
      about: "",
      firebaseUrl: "",
      imageThumbnail: "",
      imageUrl: "",
      entityId: "",
      address: "",
      phone: "",
      // entityType: "",
      location: "",
      title: "",
      website: "",
      totalScore: Number(0),
      galleryImages: [],
      dialog: false,
    };
  },
  computed: {
    ...mapState("$_home", ["entityProfile"]),
    changeFields() {
      return {
        googleUrl: this.googleUrl,
        featureImage: this.imageUrl,
        about: this.about,
        entityId: this.entityId,
        address: this.address,
        // entityType: this.entityType,
        location: this.location,
        phone: this.phone,
        title: this.title,
        website: this.website,
        totalScore: this.totalScore,
        gallery: this.galleryImages,
      };
    },
  },
  methods: {
    ...mapActions({
      getProfile: "$_home/getProfileByEntityId",
      createNewProfile: "$_home/createNewProfile",
      uploadImage: "$_content/uploadImage",
    }),
    toggleDialog(entity) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.entityId = entity.id;
        this.address = entity.address;
        // this.entityType = entity.entityType;
        this.location = entity.location;
        this.title = entity.title;
        this.website = entity.website;
        this.phone = entity.phone;
      }
      console.log("opening new Profile");
    },
    openImageGallery() {
      this.$refs.imageGalleryRef.toggleDialog();
    },
    setFeatureImage(image) {
      this.featureImage = image;
      this.galleryImageDeselect();
    },
    galleryImageSelect(image) {
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : "";
      this.imageThumbnail = image.thumbnail;
      this.imageUrl = image.url;
      if (this.featureImage.length > 0) {
        this.featureImage = [];
        this.$refs.featureImageUploadRef.removeImage(0);
      }
    },
    galleryImageDeselect() {
      this.firebaseUrl = "";
      this.imageThumbnail = "";
      this.imageUrl = "";
    },
    openImageGalleryMultipleSelect() {
      this.$refs.imageGalleryMultipleSelectRef.toggleDialog();
    },
    updateSelectedImages(images) {
      images.forEach((image) => {
        this.galleryImages.push({
          id: image.id,
          url: image.image.url,
        });
      });
      console.log("selected Images: ", images);
    },
    removeGallerySelectedImage(index) {
      this.galleryImages.splice(index, 1);
    },
    save() {
      console.log("save");
      console.log(this.changeFields);

      this.createNewProfile({
        details: this.changeFields,
        type: "Profile",
      }).then(() => {
        this.cancel();
      });
    },
    cancel() {
      this.googleUrl = "";
      this.featureImage = "";
      this.galleryImages = [];
      this.about = "";
      this.galleryImageDeselect();

      this.dialog = false;
    },
  },
};
</script>

<style>
</style>